var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.saleLayouts.length == 0
    ? _c("p", [
        _vm._v(" " + _vm._s(_vm.$t("sales.create.noSaleLayouts")) + " "),
      ])
    : !_vm.multi
    ? _c("w-select", {
        attrs: {
          items: _vm.saleLayoutItems,
          value: _vm._value,
          label: _vm._label,
          fancy: _vm.fancy,
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _c("w-multi-select", {
        attrs: {
          items: _vm.saleLayoutItems,
          value: _vm.value,
          label: _vm._label,
          fancy: _vm.fancy,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }